import {
  takeLatest,
  select,
  put,
  call,
} from 'redux-saga/effects';
import apiS from '@/api/course-session';
import apiT from '@/api/teacher';
import wss from '@/api/client-wss';
import {
  SYNC_ADD_ADMIN_SUBSCRIBER_REQUEST,
  SYNC_ADD_SUBSCRIBER_REQUEST,
  SYNC_REMOVE_SUBSCRIBER_REQUEST,
  UPDATE_SYNC_STATE,
} from '@/action-types/sync';
import { ANALYTICS_SEND_EVENT } from '@/action-types/analytics';
import { STUDENT_GET_INFO_SUCCESS } from '@/action-types/student';
import { TEACHER_GET_INFO_SUCCESS } from '@/action-types/teacher';

export function* addSubscriber(params: {
  data: {
    userId: string;
    userRole: string;
    usersInTopic: { userId: string; userRole: string; }[];
  };
}) {
  const state = yield select();

  const users = {
    [params.data.userRole]: {
      ...(state?.book?.sync?.[params.data.userRole] || {}),
      count: params.data.usersInTopic.filter((el) => `${el.userId}` === `${params.data.userId}`).length,
      id: `${params.data.userId}`,
      isConnected: true,
      uid: `${params.data.userId}`,
    },
  };
  const otherRole = params.data.userRole === 'student' ? 'teacher' : 'student';
  const otherUsers = params.data.usersInTopic.filter((el) => el.userRole === otherRole);

  users[otherRole] = {
    ...(state?.book?.sync?.[otherRole] || {}),
    count: otherUsers.length,
    id: `${otherUsers?.[0]?.userId || ''}`,
    isConnected: !!otherUsers.length,
    uid: `${otherUsers?.[0]?.userId || ''}`,
  };

  yield put({
    type: UPDATE_SYNC_STATE,
    action: 'update-sync',
    data: users,
  });

  if (params.data.userRole === 'teacher' && state.teacher?.data?.id) {
    yield put({
      type: TEACHER_GET_INFO_SUCCESS,
      data: {
        ...state.teacher.data,
      },
    });
  } else if (params.data.userRole === 'student' && state.student?.data?.id) {
    yield put({
      type: STUDENT_GET_INFO_SUCCESS,
      info: {
        ...state.student.data,
      },
    });
  }
}

export function* addAdminSubscriber() {
  const state = yield select();
  wss.publish({ action: 'user-pass-admin-state', data: state.book || {} });
}

export function* checkStudent(params: { info: { id: string; }; }) {
  const state = yield select();
  const { sync } = state.book;
  const sessionId = window.location.pathname.split('/')[2];
  const courseId = window.location.pathname.split('/')[3];

  if (sessionId && courseId && window.location.href.match('/class/')) {
    // @ts-ignore
    const response = yield call(apiS.getCourseSession, parseInt(params.info.id, 10));
    const session = (response?.data?.getCourseSession || []).filter((el: any) => `${el.id}` === sessionId)[0];

    if (session && `${session?.course?.id}` === courseId) {
      sync.student.isPermitted = true;
    } else {
      sync.student.isPermitted = (sessionId || '').match('0-');
    }

    yield put({
      type: ANALYTICS_SEND_EVENT,
      eventName: 'tech-student-check-permittion',
      data: {
        isPermitted: sync.student.isPermitted,
        location: window.location.pathname,
        sessionListId: session?.course?.id || '',
      },
    });
    yield put({
      type: UPDATE_SYNC_STATE,
      action: 'update-sync',
      data: {
        student: sync.student,
        teacher: session?.studentsList?.[0]?.teacher,
      },
    });
  }
}

export function* checkTeacher(params: { data: { id: string; }; }) {
  const state = yield select();
  const { sync } = state.book;
  const sessionId = window.location.pathname.split('/')[2];
  const courseId = window.location.pathname.split('/')[3];

  if (sessionId && courseId && window.location.href.match('/class/')) {
    // @ts-ignore
    const response = yield call(apiT.getTeacherStudentsList, parseInt(params.data.id, 10));
    const session = (response?.data?.getTeacherStudentsList || []).filter((el: any) => `${el.session.id}` === sessionId)[0];

    if (session && `${session?.session?.course?.id}` === courseId) {
      sync.teacher.isPermitted = true;
    } else {
      sync.teacher.isPermitted = (sessionId || '').match('0-');
    }

    yield put({
      type: ANALYTICS_SEND_EVENT,
      eventName: 'tech-student-check-permittion',
      data: {
        isPermitted: sync.teacher.isPermitted,
        location: window.location.pathname,
        sessionListId: session?.session?.course?.id || '',
      },
    });
    yield put({
      type: UPDATE_SYNC_STATE,
      action: 'update-sync',
      data: {
        teacher: sync.teacher,
        student: session?.session?.student,
      },
    });
  }
}

export function* removeSubscriber(params: {
  data: {
    userId: string;
    userRole: string;
    usersInTopic: { userId: string; userRole: string; }[];
  };
}) {
  const state = yield select();
  const { sync } = state.book;
  const count = params.data.usersInTopic.filter((el) => `${el.userId}` === `${params.data.userId}`).length;

  yield put({
    type: UPDATE_SYNC_STATE,
    action: 'update-sync',
    data: {
      ...sync,
      [params.data.userRole]: {
        ...(sync[params.data.userRole] || {}),
        count,
        id: `${params.data.userId}`,
        isConnected: !!count,
        uid: `${params.data.userId}`,
      },
    },
  });
}

export default function* subscriberSaga() {
  yield takeLatest<{ type: string; } & any>(SYNC_ADD_SUBSCRIBER_REQUEST, addSubscriber);
  // NOTE hidden admin should receive initial state
  yield takeLatest<{ type: string; } & any>(SYNC_ADD_ADMIN_SUBSCRIBER_REQUEST, addAdminSubscriber);
  yield takeLatest<{ type: string; } & any>(SYNC_REMOVE_SUBSCRIBER_REQUEST, removeSubscriber);
  yield takeLatest<{ type: string; } & any>(STUDENT_GET_INFO_SUCCESS, checkStudent);
  yield takeLatest<{ type: string; } & any>(TEACHER_GET_INFO_SUCCESS, checkTeacher);
}
